import * as React from 'react'
import { connect } from 'react-redux'
import CitationsUpsellWrapper from '@chegg-wt/core/components/CitationsUpsellWrapper'

import { PREMIUM_CITATIONS, FREE_CITATIONS } from '@chegg-wt/core/constants/citationFlow'
import { NEW_PROJECT_ID } from '@chegg-wt/core/constants/projects'
import sourceTypes from '@chegg-wt/core/constants/sourceTypes'
import { SourceType } from '@chegg-wt/core/types/core'
import { navigated } from '@chegg-wt/core/state/app/actions'
import { currentStyleSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { isGuestSelector } from '@chegg-wt/core/state/user/selectors'
import { useRoutesContext } from '../RoutesContext'
import SourceTypePicker from '../SourceTypePicker'
import * as Styled from './styled'
import { CITATION_WIDGET, CREATE_NEW_CITATION } from './testIds'
import * as DomIds from './domIds'
import {
  CitationWidgetProps,
  CitationWidgetStateProps,
  CitationWidgetDispatchProps,
} from './types'

export const CitationWidget: React.FC<CitationWidgetProps> = ({
  citationsExperience,
  showUpsell,
  currentStyle,
  navigated,
  onUserClickSource,
}) => {
  const {
    toSourceSearch,
    toCitationListSource,
    toCitationListForm,
    toManualCitation,
  } = useRoutesContext()

  const handleSelectSourceType = async ({ id: sourceType, manual }: SourceType) => {
    if (showUpsell) {
      return false
    }

    onUserClickSource(sourceType)
    switch (citationsExperience) {
      case PREMIUM_CITATIONS: {
        const projectId = NEW_PROJECT_ID
        const route = manual
          ? toCitationListForm({ projectId })
          : toCitationListSource({ projectId })

        return navigated(route, { query: { sourceType } })
      }

      case FREE_CITATIONS: {
        const route = manual
          ? toManualCitation({ sourceType, style: currentStyle })
          : toSourceSearch({ sourceType, style: currentStyle })

        return navigated(route)
      }

      default: {
        return null
      }
    }
  }

  const UpsellWrapper = showUpsell
    ? CitationsUpsellWrapper
    : Styled.SourceTypePickerContainer

  return (
    <Styled.Container data-test={CITATION_WIDGET} id={DomIds.CitationWidgetId}>
      <Styled.Heading data-test={CREATE_NEW_CITATION}>
        Create a new citation
      </Styled.Heading>
      <UpsellWrapper>
        <Styled.Subheading>Choose your source:</Styled.Subheading>
        <SourceTypePicker
          dropdownSourceTypes={sourceTypes.slice(3)}
          buttonSourceTypes={sourceTypes.slice(0, 3)}
          onSourceTypeSelect={handleSelectSourceType}
          isDisabled={showUpsell}
        />
      </UpsellWrapper>
    </Styled.Container>
  )
}

const mapStateToProps = (state) => ({
  currentStyle: currentStyleSelector(state),
  isGuest: isGuestSelector(state),
})

const mapDispatchToProps = {
  navigated,
}

export default connect<CitationWidgetStateProps, CitationWidgetDispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(CitationWidget)
